import { Stack, Typography, Box } from '@mui/material'
import TextBox from '../../components/TextBox'
import React, { useState } from 'react'
import { AccountBox, AccountTree, Add, Mail, PersonAdd, Phone } from '@mui/icons-material'
import CustomAutoComplete from '../../components/CustomAutoComplete'
import ButtonSubmit from '../../components/ButtonSubmit'
import { useNavigate } from 'react-router-dom'
import API from '../../services/api'
import { useEffect } from 'react'
import CustomSnackBar from '../../components/CustomSnackBar'
import MainText from '../../components/MainText'
import { useCallback } from 'react'

export default function CreateExecutive({ supplier = 0, setOpen,onClose, isModal = false, data }) {
  const [loading, setLoading] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("info");
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    lastName: "",
    phone: 0,
    role: "",
    email: "",
    supplier: supplier,
  });

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      supplier: supplier || prev.supplier || 0,
    }));
  }, [supplier]);

  const handleChange = useCallback((name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }, []);

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  try {
    const supplierId = formData?.supplier || supplier || 0;
    if (!supplierId) {
      setOpenSnack(true);
      setSnackMessage("Selecciona un proveedor");
      setSnackSeverity("error");
      setLoading(false);
      return;
    }
    const payload = {
      ...formData,
      supplier_id: supplierId,
    };
    const response = await API.post('executive/', payload);

    setOpenSnack(true);
    setSnackMessage("¡Creado con éxito!");
    setSnackSeverity("success");
    
    setTimeout(() => {
      setLoading(false);
      
      // Cerrar modal si está en modal mode
      if (isModal) {
        if (onClose && typeof onClose === 'function') {
          onClose(); // Usar onClose en lugar de setOpen
        } else if (setOpen && typeof setOpen === 'function') {
          setOpen(false); // Fallback por compatibilidad
        }
      } else {
        // Comportamiento para página normal
        if (data && typeof data === 'function') {
          data();
        }
        if (!supplier) {
          navigate('/home');
        }
      }
    }, 1500);

  } catch (error) {
    console.error("Error:", error);
    setOpenSnack(true);
    setSnackMessage("Error al crear ejecutivo");
    setSnackSeverity("error");
    setLoading(false);
  }
};

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={isModal ? {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        gap: 0,
      } : {}}
    >
      {!isModal && (
        <MainText
          title={'Ingreso de ejecutivo'}
          subtitle={'Ingresa la información'}
          icon={PersonAdd}
        />
      )}

      <Stack
        spacing={2}
        sx={isModal ? {
          width: '100%',
          maxWidth: 400,
          alignItems: 'center'
        } : {}}
      >
        <TextBox
          label='Nombre/s'
          icon={AccountBox}
          required
          minLength={0}
          maxLength={20}
          name={'name'}
          errorMessage='Campo requerido'
          onChange={handleChange}
          type='text'
          sx={isModal ? { width: '100%' } : {}}
        />
        <TextBox
          label='Apellido/s'
          icon={AccountBox}
          required
          minLength={0}
          maxLength={20}
          errorMessage='Campo requerido'
          name={'lastName'}
          onChange={handleChange}
          sx={isModal ? { width: '100%' } : {}}
        />
        <TextBox
          label={'Número de teléfono'}
          icon={Phone}
          type='number'
          required
          minLength={0}
          maxLength={8}
          errorMessage='Campo requerido'
          name={'phone'}
          onChange={handleChange}
          sx={isModal ? { width: '100%' } : {}}
        />
        <TextBox
          label={'Puesto'}
          icon={AccountTree}
          type='text'
          required
          minLength={0}
          maxLength={20}
          errorMessage='Campo requerido'
          name={'role'}
          onChange={handleChange}
          sx={isModal ? { width: '100%' } : {}}
        />
        <TextBox
          label={'Email'}
          icon={Mail}
          type='email'
          name={'email'}
          onChange={handleChange}
          sx={isModal ? { width: '100%' } : {}}
        />
        <CustomAutoComplete
          name={"supplier"}
          onChange={handleChange}
          supplier={supplier}
          sx={isModal ? { width: '100%' } : {}}
        />

        <Box sx={isModal ? {
          display: 'flex',
          justifyContent: 'center',
          width: '100%'
        } : {}}>
          <ButtonSubmit
            name='Crear'
            icon={Add}
            loading={loading}
            color='primary'
            sx={isModal ? { width: '100%', maxWidth: 200 } : {}}
          />
        </Box>
      </Stack>

      {openSnack && (
        <CustomSnackBar
          open={openSnack}
          setOpen={setOpenSnack}
          message={snackMessage}
          severity={snackSeverity}
        />
      )}
    </Box>
  )
}
